import { useMutation, useQueryClient } from '@tanstack/react-query';
import PromptService from '../../../services/prompt-service';

const useDeletePrompt = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (promptId: number) => PromptService.deletePrompts(promptId),
    onSuccess: () => {
      // Invalidate and refetch prompts list
      queryClient.invalidateQueries({ queryKey: ['prompts'] });
    },
  });
};

export default useDeletePrompt;
